export const CHART_TYPE_PIE =1;
export const CHART_TYPE_BAR =2;
export const CHART_TYPE_LINE =3;
export const CHART_TYPE_CARD =4;
export const CHART_TYPE_DOUGHNUT =5;
export const CHART_TYPE_TABLE=6;
export const CHART_TYPE_LIST =7;
export const CHART_TYPE_TASK_TABLE =61;

export const DASHBOARD_FROM_DATE='2026-01-01'

export const SYSTEM_ID_MEDICAL_CORE= 3;
export const SYSTEM_ID_MEDICAL_CORE_TEXT= 'MEDICAL CORE';

export const SYSTEM_ID_SECURITY= 2;
export const SYSTEM_ID_MEDICAL_SECURITY_TEXT= 'SECUIRTY';


